import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  cancelPreviousRequest,
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const studySubjectManagementServices = {
  //Subject Column
  addNewStudySubjectColumn,
  updateStudySubjectColumnData,
  deleteStudySubjectColumnData,
  softDeleteRestoreStudySubjectColumn,
  getStudySubjectColumnData,

  //Subject Row
  addNewStudySubjectRow,
  assignRandomizationNumber,
  updateStudySubjectRowData,
  deleteStudySubjectRowData,
  softDeleteRestoreStudySubjectRow,
  getStudySubjectRowData,
  getStudySiteSubjectData,
  getStudySiteSubjectRandomizationData,
  getStudySubjectRandomizationBySite,
  getTotalSubject,
  getTotalLar,
  getEPROSubjectRewardDashboardData,
  getTotalVoidSubject,
  getStudyFormNotificationDashboardStats,
  getStudyFormQueryDashboardStats,
  getStudyFormSDVDashboardStats,
  getStudySingleSubjectRow,
  getFormReportBasedonSubject,
  getHeighestVersionSubjectRowHistory,
  getStudySubjectAuditTrials,
  getStudySubjectScreenFailedHistoryData,
  getStudySubjectDiscontinueHistoryData,
};

// Get Study Subject Column
async function getStudySubjectColumnData(
  status,
  studyId,
  siteId,
  searchData,
  page,
  length
) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySubjectColumnData/${status}/${studyId}/${siteId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySubjectColumnData/${status}/${studyId}/${siteId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Subject Column
async function addNewStudySubjectColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySubjectColumn`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Update Study Subject Column
async function updateStudySubjectColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudySubjectColumnData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Soft Delete & Restore Study Subject Column
async function softDeleteRestoreStudySubjectColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySubjectColumn`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Study Subject Column
async function deleteStudySubjectColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudySubjectColumnData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Assign Randomization Number
async function assignRandomizationNumber(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignRandomizationNumber`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Study Subject Row
async function getStudySubjectRowData(
  status,
  studyId,
  siteId,
  mode,
  searchData,
  page,
  length
) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySubjectRow/${status}/${studyId}/${siteId}/${mode}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySubjectRow/${status}/${studyId}/${siteId}/${mode}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study Subject Row
async function getStudySiteSubjectData( studyId, category, mode, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteSubjectData/${studyId}/${category}/${mode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteSubjectData/${studyId}/${category}/${mode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study Subject Row
async function getStudySiteSubjectRandomizationData(
  status,
  studyId,
  schemaId,
  category,
  mode,
  page,
  length,
  filters = {}
) {
  const queryParams = new URLSearchParams();
  if (page && length) {
    queryParams.set("page", page);
    queryParams.set("length", length);
  }
  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryParams.set(key, value);
    }
  });
  const query = queryParams.toString();
  let response;
  response = await fetch(
    `${
      config.API_URL_USER_ONBOARDING
    }getStudySiteSubjectRandomizationData/${status}/${studyId}/${schemaId}/${category}/${mode}${query ? `?${query}` : ""}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Subject Screen Failed
async function getStudySubjectScreenFailedHistoryData(
  studyId,
  mode,
  searchData,
  page,
  length
) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySubjectScreenFailedHistoryData/${studyId}/${mode}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySubjectScreenFailedHistoryData/${studyId}/${mode}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study Subject Discontinue
async function getStudySubjectDiscontinueHistoryData(
  studyId,
  mode,
  searchData,
  page,
  length
) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySubjectDiscontinueHistoryData/${studyId}/${mode}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySubjectDiscontinueHistoryData/${studyId}/${mode}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Subject Row
async function addNewStudySubjectRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySubjectRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Update Study Subject Row
async function updateStudySubjectRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudySubjectRowData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Soft Delete & Restore Study Subject Row
async function softDeleteRestoreStudySubjectRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySubjectRow`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Study Subject Row
async function deleteStudySubjectRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudySubjectRowData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Study Subject Row
async function getStudySubjectAuditTrials(studyId, subjectId, siteId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectAuditTrials/${studyId}/${subjectId}/${siteId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Single Subject Row
async function getStudySingleSubjectRow(studyId, siteId, subjectId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySingleSubjectRow/${studyId}/${siteId}/${subjectId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Subject Randomization By Site
async function getStudySubjectRandomizationBySite(studyId, siteId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectRandomizationBySite/${studyId}/${siteId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Total Subject
async function getTotalSubject(studyId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTotalSubject/${studyId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Total Lar
async function getTotalLar(studyId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTotalLar/${studyId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Total Subject Reward
async function getEPROSubjectRewardDashboardData(studyId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getEPROSubjectRewardDashboardData/${studyId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Total Void Subject
async function getTotalVoidSubject(studyId, siteId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTotalVoidSubject/${studyId}/${siteId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Notification Dashboard Stats
async function getStudyFormNotificationDashboardStats(studyId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormNotificationDashboardStats/${studyId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Query Dashboard Stats
async function getStudyFormQueryDashboardStats(studyId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormQueryDashboardStats/${studyId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form SDV Dashboard Stats
async function getStudyFormSDVDashboardStats(studyId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSDVDashboardStats/${studyId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Event Row Heighest version
async function getHeighestVersionSubjectRowHistory(studyId, subjectId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getHeighestVersionSubjectRowHistory/${studyId}/${subjectId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Form Report Based on Subject
async function getFormReportBasedonSubject(studyId, siteId, subjectId, mode, allowCancel = true) {
    try {
        const signal = allowCancel ? cancelPreviousRequest("getFormReportBasedonSubject") : undefined;
        let apiURL = `${config.API_URL_USER_ONBOARDING}getFormReportBasedonSubject/${studyId}/${siteId}/${subjectId}/${mode}`
        const response = await fetch(apiURL, {
            ...headersWithAuthWithoutBody("GET", headers),
            ...(signal && { signal })
        });
        const data = await response.json();
        return data;
    } catch (err) {
        if (err.name === "AbortError") {
            return "AbortError";
        }
        throw err;
    }
}
